import React, { memo } from "react";
import { round } from "utils/formatters";

import { images } from "constants/images";

type Props = {
  image?: string;
  title: string;
  value: number;
};

export const MotionCard = memo(({ image = "", title, value }: Props) => {
  return (
    <div className="flex flex-col items-center p-3 relative z-[1]  ">
      <img
        src={images.rangeBg}
        alt="range-bg"
        className="w-full h-full absolute z-[-1] rounded-[27px] object-contain top-0 left-0"
      />

      <div className="w-14 h-14 rounded-[20px] bg-grayDark">
        {image && (
          <img
            src={`data:image/png;base64,${image}`}
            alt="range-bg"
            className="w-full h-full rounded-[20px] object-cover "
          />
        )}
      </div>
      <strong className="text-grayDark font-medium text-[13px] mt-1">
        {title}: {value ? round(value, 1) : "N/A"}
      </strong>
    </div>
  );
});
